<template>
  <div class="Error">
    <div class="ErrorBox">
      <img class="pic" :src="picUrl+'qunaer/common/404.png'" alt="404资源访问不到">
      <p class="text">找不到页面了</p>
    </div>
  </div>
</template>

<script>
import { getPicUrl } from '@/utils/auth'
export default {
  name: 'Error',
  data() {
    return {
      msg: '对不起，您请求的页面不存在、或已被删除、或暂时不可用',
      picUrl: getPicUrl()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Error {
  padding: 0 30px;
  width: calc(100% - 60px);
}
.ErrorBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 82px;
}
.ErrorBox .pic {
  width: 400px;
  height: 400px;
}
.ErrorBox .text {
  margin-bottom: 60px;
  width: 100%;
  line-height: 40px;
  font-size: 28px;
  text-align: center;
  color: #999;
}
.ErrorBox .button {
  font-weight: bold;
}
</style>
